"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var tim_1 = require("../../../../TUICore/tim");
var vue_1 = require("vue");
var manage_vue_1 = require("./manage.vue");
var memberProfile = vue_1.defineComponent({
    props: {
        userInfo: {
            type: Object,
            default: function () { return ({}); },
        },
    },
    setup: function (props, ctx) {
        var _this = this;
        var TUIServer = manage_vue_1.default === null || manage_vue_1.default === void 0 ? void 0 : manage_vue_1.default.TUIServer;
        var data = vue_1.reactive({
            isFriendShip: false,
            userInfo: {},
            self: {},
        });
        vue_1.watchEffect(function () {
            data.self = props.self;
        });
        vue_1.watch(function () { return props.userInfo; }, function (newVal, oldVal) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (newVal === oldVal)
                            return [2 /*return*/];
                        return [4 /*yield*/, TUIServer.getUserProfile([(_a = props === null || props === void 0 ? void 0 : props.userInfo) === null || _a === void 0 ? void 0 : _a.userID])];
                    case 1:
                        res = _b.sent();
                        data.userInfo = res === null || res === void 0 ? void 0 : res.data[0];
                        checkFriend();
                        return [2 /*return*/];
                }
            });
        }); }, {
            deep: true,
            immediate: true,
        });
        var enter = function (ID, type) { return __awaiter(_this, void 0, void 0, function () {
            var name;
            return __generator(this, function (_a) {
                name = "" + type + ID;
                TUIServer.TUICore.TUIServer.TUIConversation.getConversationProfile(name).then(function (imResponse) {
                    // 通知 TUIConversation 添加当前会话
                    // Notify TUIConversation to toggle the current conversation
                    TUIServer.TUICore.TUIServer.TUIConversation.handleCurrentConversation(imResponse.data.conversation);
                });
                return [2 /*return*/];
            });
        }); };
        var checkFriend = function () { return __awaiter(_this, void 0, void 0, function () {
            var relation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.userInfo.userID)
                            return [2 /*return*/];
                        return [4 /*yield*/, TUIServer.checkFriend(data.userInfo.userID, tim_1.default.TYPES.SNS_CHECK_TYPE_BOTH)];
                    case 1:
                        relation = _a.sent();
                        data.isFriendShip = relation === tim_1.default.TYPES.SNS_TYPE_BOTH_WAY ? true : false;
                        return [2 /*return*/];
                }
            });
        }); };
        var showEnter = function () {
            var _a;
            return data.isFriendShip || !((_a = TUIServer === null || TUIServer === void 0 ? void 0 : TUIServer.TUICore) === null || _a === void 0 ? void 0 : _a.isOfficial);
        };
        return __assign(__assign({}, vue_1.toRefs(data)), { enter: enter,
            showEnter: showEnter });
    },
});
exports.default = memberProfile;
